export function TopGradient(): JSX.Element {
  return (
    <div className="absolute z-40 h-10 w-full bg-gradient-to-b from-[rgba(44,57,63,0.3)]" />
  );
}
